import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./styles.module.css";
import LightningBoltIcon from "components/common/icons/LightningBoltIcon";
import { useAppSelector } from "state/hooks.ts";
import { DOLLAR_SIGN, getGroupCurrencySymbol, getGroupStyles } from "state/slices/group-slice.ts";
import { textColor } from "utils/constants.ts";

interface Props {
  show: boolean;
  entryFee: number;
  onHide: () => void;
  initialBalance: number;
}

const ContestPostJoinInfoModal: React.FC<Props> = ({ show, entryFee, onHide, initialBalance }) => {
  const currencySymbol = useAppSelector(state => getGroupCurrencySymbol(state));
  const primaryColor = useAppSelector(getGroupStyles).primary_color;

  const contestInitialBalance = <span
    className={styles.boldUnderline}>{currencySymbol}{initialBalance}&nbsp;Sparks</span>;
  return (
    <Modal show={show} onHide={onHide} centered dialogClassName={styles.modalDialog}>
      <Modal.Body className={styles.modalBody} style={{ backgroundColor: primaryColor }}>
        <button onClick={onHide} style={{ color: textColor }} className={styles.closeButton} aria-label="Close">
          &times;
        </button>
        <LightningBoltIcon className={styles.lightningIcon} color={textColor} />

        <div className={styles.mainContentFrame}>
          <div className={styles.headerText}>
            Your <span className={styles.boldUnderline}>{entryFee === 0 ? "FREE" :
            <span>{DOLLAR_SIGN}{entryFee}</span>} </span>
            entry gives you&nbsp;
            {contestInitialBalance}<span className={styles.boldUnderline}>.</span>
          </div>

          <div className={styles.stepsContainer}>
            <div className={styles.stepItem}>
              <div className={styles.stepNumber} style={{ color: primaryColor, backgroundColor: textColor }}>1</div>
              <div className={styles.stepText}>
                Use your {contestInitialBalance} to make <span className={styles.bold}>at least 3 unique picks.</span>
              </div>
            </div>
            <div className={styles.stepItem}>
              <div className={styles.stepNumber} style={{ color: primaryColor, backgroundColor: textColor }}>2</div>
              <div className={styles.stepText}>
                Climb the <span className={styles.bold}>Leaderboard</span> by winning picks.
              </div>
            </div>
            <div className={styles.stepItem}>
              <div className={styles.stepNumber} style={{ color: primaryColor, backgroundColor: textColor }}>3</div>
              <div className={styles.stepText}>
                <span className={styles.bold}>Prizes</span> are awarded based on
                <span className={styles.bold}> Leaderboard</span> position.
              </div>
            </div>
          </div>
        </div>

        <div className={styles.proTip}>
          <span className={styles.bold}>Pro Tip: </span>
          Use your <span className={styles.bold}>skill </span>
          to <span className={styles.bold}>pick the best odds</span> to
          <span className={styles.bold}> earn the most Sparks. Odds are dynamic </span>
          based on user activity and can change until the close time of each pool.
        </div>

        <div className={styles.closeButtonContainer}>
          <Button 
            onClick={onHide}
            className={styles.bottomCloseButton}
            style={{ 
              backgroundColor: textColor,
              color: primaryColor,
              border: 'none',
              padding: '8px 24px',
              borderRadius: '4px',
              fontWeight: 'bold'
            }}
          >
            Let's Go!
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContestPostJoinInfoModal;